import React from 'react';
import './App.css';
import Emoji from './emoji'

function App() {
  return (
    <div className="App">
      <header className="App-header">
      <Emoji symbol="👋" label="wave"/>
      <p>hi</p>
      </header>
    </div>
  );
}

export default App;
